import React, { useEffect } from 'react'
import { FuseAnimateGroup } from '@fuse'
import LoginForm from './LoginForm'
import { useSuspendStatus } from 'app/auth/useSuspendStatus'
import Suspended from 'app/components/Suspended'
import CommonBackground from 'app/components/CommonBackground'
import ContainerNotifyMeCard from 'app/components/ContainerNotifyMeCard'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'
import MessageAlert from 'app/components/MessageAlert'
import effects from 'app/effects/effects'
import { useAppName } from 'commons/usePartner'
import { useFlag, useFlagsStatus } from '@unleash/proxy-client-react'
import LoginV4 from './V4/LoginV4'
import { logoutFrontEnd } from 'app/auth/store/actions'

function Login(props) {
  const { suspendStatus, clearSuspendStatus } = useSuspendStatus()
  const { formatMessage } = useIntl()
  const dispatch = useDispatch()
  const appName = useAppName()

  const { flagsReady } = useFlagsStatus('mes_1960_new_signin_signup')
  const mes_1960_new_signin_signup = useFlag('mes_1960_new_signin_signup')

  useEffect(() => {
    effects.apis.healtCheck().catch((error) => {
      if (
        error &&
        error.response.data.status === 503 &&
        error.response.data.details &&
        error.response.data.details.code === 700
      ) {
        logoutFrontEnd(dispatch)
        dispatch({
          type: 'DISABLED_MAINTENANCE',
          value: true,
        })
        props.history.push('/maintenance')
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (suspendStatus.teamMember)
      dispatch(
        MessageAlert.showError({
          message: formatMessage(
            {
              id: 'suspended.teamMember',
            },
            { newline: <br />, appName },
          ),
        }),
      )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [suspendStatus.teamMember, dispatch, formatMessage])

  if (!flagsReady || mes_1960_new_signin_signup) return <LoginV4 />

  return (
    <CommonBackground>
      {suspendStatus.place ? (
        <ContainerNotifyMeCard>
          <div className="flex flex-col">
            <Suspended
              reason={suspendStatus.place}
              onClose={clearSuspendStatus}
            />
          </div>
        </ContainerNotifyMeCard>
      ) : (
        <ContainerNotifyMeCard
          footerMessage={formatMessage({
            id: 'login.contentBottom',
          })}
        >
          <div className="flex flex-col w-full">
            <FuseAnimateGroup
              enter={{ animation: 'fadeIn' }}
              leave={{ animation: 'fadeOut' }}
            >
              <LoginForm />
            </FuseAnimateGroup>
          </div>
        </ContainerNotifyMeCard>
      )}
    </CommonBackground>
  )
}

export default Login
